import { Box, Button, HStack, Icon, Text, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

import { ReportGeneratorSubCategory } from '../../../../store/reportGenerator/categories';
import { reportGeneratorTheme } from '../../constants/theme';

export interface ReportCategoryCardProps {
  subCategory: ReportGeneratorSubCategory;
  width: number;
  onGenerateReport: (subCategory: ReportGeneratorSubCategory) => void;
}

export const ReportCategoryCard: React.FC<ReportCategoryCardProps> = ({
  subCategory,
  width,
  onGenerateReport,
}) => {
  const { iconography, canRequest } = subCategory;

  return (
    <VStack
      width={`${width}px`}
      minH="240px"
      p="inline.xxs"
      bg={reportGeneratorTheme.card.bg}
      borderRadius="md"
      borderWidth={1}
      borderColor={reportGeneratorTheme.card.borderColor}
      alignItems="flex-start"
      justifyContent="space-between"
      opacity={canRequest ? 1 : 0.72}
      style={{
        shadowColor: 'transparent',
        shadowOpacity: 0,
        shadowRadius: 0,
        shadowOffset: { width: 0, height: 0 },
        elevation: 0,
        boxShadow: 'none',
      }}>
      <VStack width="full" space="stack.xxxs" alignItems="flex-start" flex={1}>
        <Box
          w="inline.md"
          h="inline.md"
          bg={iconography.backgroundColor as any}
          borderRadius="sm"
          p="inline.nano"
          alignItems="center"
          justifyContent="center">
          <Icon
            name={iconography.name}
            size={iconography.size}
            color={iconography.color as any}
            testId={`report-subcategory-icon-${subCategory.id}`}
          />
        </Box>

        <VStack width="full" space="stack.quarck" alignItems="flex-start" flex={1}>
          <HStack alignItems="center" space="inline.nano" flexWrap="wrap" pr="inline.quarck">
            <Text
              fontSize={18}
              fontWeight="semibold"
              color={reportGeneratorTheme.card.title}
              selectable={false}>
              {subCategory.label}
            </Text>
            <Box
              bg={reportGeneratorTheme.newBadge.bg}
              borderRadius="sm"
              px="inline.quarck"
              py="1px"
              alignItems="center"
              justifyContent="center">
              <Text
                variant="semibold"
                fontSize={Typography['fontsize.xs']}
                color={reportGeneratorTheme.newBadge.color}
                selectable={false}>
                Novo
              </Text>
            </Box>
          </HStack>

          <Text
            fontSize={Typography['fontsize.xs']}
            color={reportGeneratorTheme.card.description}
            numberOfLines={3}
            selectable={false}
            flex={1}>
            {subCategory.description || ' '}
          </Text>
        </VStack>
      </VStack>

      <Button
        variant="textLink"
        alignSelf="flex-start"
        p={0}
        isDisabled={!canRequest}
        onPress={() => {
          if (canRequest) {
            onGenerateReport(subCategory);
          }
        }}
        _text={{
          color: canRequest ? reportGeneratorTheme.colors.carouselGenerateLink : 'neutral.medium',
          fontSize: Typography['fontsize.md'],
          textTransform: 'none',
        }}
        rightIcon={
          <Icon
            name="ChevronRight"
            size="xxs"
            color={canRequest ? reportGeneratorTheme.colors.carouselGenerateLink : 'neutral.medium'}
            testId=""
          />
        }>
        {canRequest ? 'Gerar novo Relatório' : 'Em breve'}
      </Button>
    </VStack>
  );
};
